<template>
  <Container>
    <ClientOnly>
      <Teaser
        v-if="employer"
        :title="employer.title"
        :to="employer.url?.path"
        :body="
          $texts('dynamicContactSelectedDescription')
        "
      />
    </ClientOnly>
    <form
      class="rounded-large bg-white p-20 shadow-lg not-first:hidden lg:p-24"
      @submit.prevent="onSubmit"
    >
      <h2 class="typo-h3 font-semibold tracking-wide">
        {{
          $texts('dynamicContactTitle')
        }}
      </h2>
      <p class="mb-24 mt-20 text-balance text-xl">
        {{
          $texts('dynamicContactDescription')
        }}
      </p>

      <SearchInput
        id="search-employer"
        v-model="searchText"
        :label="$texts('default.searchEmployer')"
      />
    </form>
  </Container>
</template>

<script lang="ts" setup>
const { employer } = useVisitorState()

defineBlokkliFragment({
  name: 'dynamic_contact',
  label: 'Dynamic Contact',
})

const searchText = ref('')

const router = useRouter()

function onSubmit() {
  router.push({
    name: 'choose-employer',
    query: {
      text: searchText.value,
    },
  })
}
</script>
